var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79 13.8384C8.18 14.2284 8.81 14.2284 9.2 13.8384L12.79 10.2484C13.18 9.8584 13.18 9.2284 12.79 8.8384L9.2 5.2484C9.01317 5.06115 8.75952 4.95592 8.495 4.95592C8.23048 4.95592 7.97683 5.06115 7.79 5.2484C7.4 5.6384 7.4 6.2684 7.79 6.6584L9.67 8.5484H1C0.45 8.5484 0 8.9984 0 9.5484C0 10.0984 0.45 10.5484 1 10.5484H9.67L7.79 12.4284C7.4 12.8184 7.41 13.4584 7.79 13.8384ZM16 0.548401H2C0.89 0.548401 0 1.4484 0 2.5484V5.5484C0 6.0984 0.45 6.5484 1 6.5484C1.55 6.5484 2 6.0984 2 5.5484V3.5484C2 2.9984 2.45 2.5484 3 2.5484H15C15.55 2.5484 16 2.9984 16 3.5484V15.5484C16 16.0984 15.55 16.5484 15 16.5484H3C2.45 16.5484 2 16.0984 2 15.5484V13.5484C2 12.9984 1.55 12.5484 1 12.5484C0.45 12.5484 0 12.9984 0 13.5484V16.5484C0 17.6484 0.9 18.5484 2 18.5484H16C17.1 18.5484 18 17.6484 18 16.5484V2.5484C18 1.4484 17.1 0.548401 16 0.548401Z",
    fill: "#314380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/loginIcon.d12ef2d2286c3da3d5605f9fa68ff990.svg";
export { ForwardRef as ReactComponent };